import React, { useEffect, useState } from 'react';
import { bindActionCreators } from 'redux';
import { useParams } from 'react-router-dom';
import { useSnackbar } from 'notistack';
import { connect } from 'react-redux';
import Paper from '@/modules/common/components/Paper';
import Button from '@/modules/common/components/Button';
import Content from '@/modules/common/components/Content';
import Spinner from '@/modules/common/components/Spinner';
import ErrorFetch from '@/modules/common/components/ErrorFetch';
import Pagination from '@/modules/common/components/Pagination';
import ContentBody from '@/modules/common/components/ContentBody';
import ContentHeader from '@/modules/common/components/ContentHeader';
import ContentBodyTop from '@/modules/common/components/ContentBodyTop';
import { withFetch } from '~/hocs/fetch';
import { withRouter } from '~/hocs/router';
import { getCfgOffer } from '~/common';
import { actionDockSetExpandNotes } from '@/modules/application/actions/dock';
import Table from './Table';
import DialogAdd from './DialogAdd';
import DialogView from './DialogView';
import DialogEdit from './DialogEdit';
import ContextMenu from './ContextMenu';
import DialogDelete from './DialogDelete';
import '../styles/Notes.scss';

const initialBreadcrumbs = [
    {name: 'Заметки'},
];

let abortController;

const Notes = (props) => {
    const { offerName } = useParams();
    const { enqueueSnackbar } = useSnackbar();

    const [breadcrumbs, setBreadcrumbs] = useState(initialBreadcrumbs);
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState(null);
    const [selectedNote, setSelectedNote] = useState(null);
    const [openDialogAdd, setOpenDialogAdd] = useState(false);
    const [openDialogView, setOpenDialogView] = useState(false);
    const [openDialogEdit, setOpenDialogEdit] = useState(false);
    const [openDialogDelete, setOpenDialogDelete] = useState(false);
    const [positionContextMenu, setPositionContextMenu] = useState({left: null, top: null});

    const fetch = () => {
        abortController = new AbortController();

        let urlSearchParams = new URLSearchParams(props.router.urlSearchParams.toString());
        if (offerName) {
            urlSearchParams.set('offer_name', offerName);
        }
        setLoading(true);
        props.fetch.get(`/api/notes/?${urlSearchParams.toString()}`, abortController)
            .then(({ok, data}) => {
                if (ok) {
                    setData(data);
                }
                setLoading(false);
            })
            .catch((error) => {
                setData(null);
                if (error.name !== 'AbortError') {
                    setLoading(false);
                }
            })
            .finally(() => {
                abortController = null;
            });
    };

    const closeContextMenu = () => {
        setPositionContextMenu({left: null, top: null});
    };

    useEffect(() => {
        return () => {
            if (abortController) {
                abortController.abort();
            }
        };
    }, []);

    useEffect(() => {
        let bc = [...initialBreadcrumbs];
        let page = parseInt(props.router.urlSearchParams.get('page'));

        if (offerName) {
            const cfgOffer = getCfgOffer(props.cfgOffers, offerName);
            if (cfgOffer) {
                if (props.cfgOffers.find((cfgOffer) => cfgOffer.show_in_notes_menu && cfgOffer.offer_name === offerName)) {
                    props.dockSetExpandNotes(true);
                    bc[0].to = '/notes/';
                    bc.push({name: offerName});
                }
            }
            else {
                props.history.push('/notes/');
                return;
            }
        }

        if (isNaN(page)) {
            page = 1;
        }
        // noinspection JSCheckFunctionSignatures
        props.router.urlSearchParams.set('page', page);

        setBreadcrumbs(bc);
        fetch();
    }, [props.history.location.search]);

    /******************************************************************************************************************/

    const handleContextMenu = (note) => (event) => {
        event.preventDefault();
        setSelectedNote(note);
        setPositionContextMenu({left: event.clientX, top: event.clientY});
    };

    const handleClickView = () => {
        closeContextMenu();
        setOpenDialogView(true);
    };

    const handleClickEdit = () => {
        closeContextMenu();
        setOpenDialogEdit(true);
    };

    const handleClickDelete = () => {
        closeContextMenu();
        setOpenDialogDelete(true);
    };

    const handleCloseContextMenu = () => {
        closeContextMenu();
        setSelectedNote(null);
    };

    /******************************************************************************************************************/

    const handleAddOk = () => {
        setOpenDialogAdd(false);
        props.history.push('/notes/');
        enqueueSnackbar('Заметка добавлена', {variant: 'success'});
    };

    const handleEditOk = () => {
        setOpenDialogEdit(false);
        setSelectedNote(null);
        props.router.reload();
        enqueueSnackbar('Заметка изменена', {variant: 'success'});
    };

    const handleDeleteOk = () => {
        setOpenDialogDelete(false);
        setSelectedNote(null);
        props.router.reload();
        enqueueSnackbar('Заметка удалена', {variant: 'success'});
    };

    /******************************************************************************************************************/

    // noinspection JSUnresolvedVariable
    return (
        <Content id="notes">
            <ContentHeader breadcrumbs={breadcrumbs}/>
            <ContentBody><Paper>
                {(!loading)
                    ? <>
                        {(data && data.results)
                            ? <>
                                <ContentBodyTop left={
                                    <Button onClick={() => setOpenDialogAdd(true)}>Добавить</Button>
                                }/>
                                <DialogAdd open={openDialogAdd} setOpen={setOpenDialogAdd} onOk={handleAddOk}/>
                                {(data.results.length > 0)
                                    ? <>
                                        <Table notes={data.results} selectedNote={selectedNote}
                                               onContextMenu={handleContextMenu}
                                        />
                                        <ContextMenu position={positionContextMenu}
                                                     onClickView={handleClickView}
                                                     onClickEdit={handleClickEdit}
                                                     onClickDelete={handleClickDelete}
                                                     onClose={handleCloseContextMenu}
                                        />
                                        <DialogView selectedNote={selectedNote} setSelectedNote={setSelectedNote}
                                                    open={openDialogView} setOpen={setOpenDialogView}
                                        />
                                        <DialogEdit selectedNote={selectedNote} setSelectedNote={setSelectedNote}
                                                    open={openDialogEdit} setOpen={setOpenDialogEdit}
                                                    onOk={handleEditOk}
                                        />
                                        <DialogDelete selectedNote={selectedNote} setSelectedNote={setSelectedNote}
                                                      open={openDialogDelete} setOpen={setOpenDialogDelete}
                                                      onOk={handleDeleteOk}
                                        />
                                        <Pagination totalPages={data.total_pages} currentPage={data.current_page}/>
                                    </>
                                    : null
                                }
                            </>
                            : <ErrorFetch onClick={() => fetch()}/>
                        }
                    </>
                    : <Spinner/>
                }
            </Paper></ContentBody>
        </Content>
    );
};

let Component = Notes;
Component = withRouter(Component);
Component = withFetch(Component);

export default connect(
    (state) => ({
        cfgOffers: state.cfg.offers,
    }),
    (dispatch) => ({
        dockSetExpandNotes: bindActionCreators(actionDockSetExpandNotes, dispatch),
    })
)(Component);
